export * from './SimilarFAQList'
export { default } from './SimilarFAQList'
